import type { IconProps } from "./types";

export function SymbolIcon({
  size,
  width = 27,
  height = 32,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
      ? color
      : `var(--${color})`;
  return (
    <svg
      width={size ?? width}
      height={size ?? height}
      viewBox="0 0 27 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 15.8539C0 22.5007 2.05996 31.7256 13.4609 31.7256C24.8663 31.7256 26.9217 22.5007 26.9217 15.8539"
        fill={currentColor}
      />
      <path d="M9.48345 0H4.45972V11.4101H9.48345V0Z" fill={currentColor} />
      <path d="M22.4617 0H17.438V11.4101H22.4617V0Z" fill={currentColor} />
    </svg>
  );
}
